import theme from './theme.js'

const pages = []
const pagesMap = {}
pages.forEach(page => {
  pagesMap[page.name] = page
})

const pagesConfig = {
  theme,
  pagesMap: {
    ...pagesMap,
  },
}

export default pagesConfig
